import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.availableItems,"label":_vm.label,"item-text":_vm.itemText,"item-value":"ID","clearable":_vm.clearable,"rules":_vm.rules,"loading":_vm.loading},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }